import { useTranslation } from 'react-i18next';
import { Spinner } from '../../../../Feedback/Spinner';
import { Check } from '../../../../Icons';
import { Warning } from '../../../../PictogramCircle/Pictograms';
import { type UploadStatus } from '../..';
import { FileUploadStatusText, FileUploadStatusWrapper } from './styles';

export const FileUploadStatusIcon = ({ uploadStatus }: { uploadStatus: UploadStatus }) => {
  const { t } = useTranslation();

  switch (uploadStatus) {
    case 'uploading':
      return (
        <FileUploadStatusWrapper>
          <Spinner size="tiny" />

          <FileUploadStatusText>{`${t('component.fileupload.status.uploading')}...`}</FileUploadStatusText>
        </FileUploadStatusWrapper>
      );
    case 'completed':
      return (
        <FileUploadStatusWrapper>
          <Check width="24px" height="24px" />

          <FileUploadStatusText>{t('component.fileupload.status.completed')}</FileUploadStatusText>
        </FileUploadStatusWrapper>
      );
    case 'failed':
      return (
        <FileUploadStatusWrapper>
          <Warning width="24px" height="24px" />

          <FileUploadStatusText>{t('component.fileupload.status.failed')}</FileUploadStatusText>
        </FileUploadStatusWrapper>
      );
    default:
      return null;
  }
};
